import React from "react";
import { DIAS_SEMANA, estiloEstatus } from "./datosVisitas";

// Vista de calendario — mensual o semanal, datos reales (fechaObj parseada de fecha_visita)
export const VisitasCalendario = ({ modo, celdas, semana, hoy, hoyMes, hoyAnio, mesActual, anioActual, onOpenDetalle }) => {
  if (modo === "semana") {
    return (
      <div className="vp-calendario vp-calendario-semana">
        <div className="vp-cal-header-row">
          {semana.map((d) => {
            const esHoy = d.numero === hoy && d.mes === hoyMes && d.anio === hoyAnio;
            return (
              <div key={d.numero + "-" + d.mes + "-" + d.anio} className="vp-cal-header-cell vp-cal-header-cell-semana">
                <div className="vp-cal-header-dia">{d.diaSemana}</div>
                <div className={`vp-cal-daynum${esHoy ? " vp-cal-daynum-hoy" : ""}`}>
                  {d.numero}
                </div>
              </div>
            );
          })}
        </div>
        <div className="vp-cal-grid vp-cal-grid-semana">
          {semana.map((d) => (
            <div key={d.numero + "-" + d.mes} className="vp-cal-cell vp-cal-cell-semana">
              <div className="vp-cal-visitas scroll">
                {d.visitas.map((v) => (
                  <div key={v.id_visita} className="vp-cal-visita vp-cal-visita-semana" onClick={() => onOpenDetalle(v)}>
                    <div className="vp-cal-visita-nombre">{v.razon_social}</div>
                    <div className="vp-cal-visita-hora">{v.vendedor}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="vp-calendario">
      <div className="vp-cal-header-row">
        {DIAS_SEMANA.map((d) => (
          <div key={d} className="vp-cal-header-cell">{d}</div>
        ))}
      </div>
      <div className="vp-cal-grid">
        {celdas.map((cell, idx) => {
          const esHoy = cell.actual && cell.numero === hoy && mesActual === hoyMes && anioActual === hoyAnio;
          return (
            <div key={idx} className={`vp-cal-cell${!cell.actual ? " vp-cal-cell-dim" : ""}`}>
              <div className={`vp-cal-daynum${esHoy ? " vp-cal-daynum-hoy" : ""}`}>{cell.numero}</div>
              <div className="vp-cal-visitas scroll">
                {cell.visitas.map((v) => (
                  <div key={v.id_visita} className="vp-cal-visita" onClick={() => onOpenDetalle(v)}>
                    <span className="vp-cal-visita-dot" style={{ background: estiloEstatus(v.estatus).fg }} />
                    <span className="vp-cal-visita-nombre">{v.razon_social}</span>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
